exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attendance-filter-container[data-v-418a28c0] {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n  max-width: 100%;\n}\n@media (min-width: 786px) {\n.attendance-filter-container[data-v-418a28c0] {\n    margin-bottom: 0;\n}\n}\n.attendance-filter-inner-container[data-v-418a28c0] {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  max-width: 100%;\n}\n@media (min-width: 768px) {\n.attendance-filter-inner-container[data-v-418a28c0] {\n    flex-direction: row;\n}\n}\n.attendance-filter-input[data-v-418a28c0] {\n  width: 100%;\n}", ""]);

// exports
